import styled from "@emotion/styled";

const Wrapper = styled("div")`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  ${props => props.theme.bp.below.lg} {
    grid-template-columns: 1fr;
  }
`;

const CardRow = ({ children, className }) => {
  return (
    <Wrapper className={className}>
      {children}
    </Wrapper>
  )
}

export default CardRow;